import axios from "axios";

const http = axios.create({
  // baseURL: "/api",
  baseURL: "https://api.gatsibo.savinga.rw/api", // Laravel API base
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

http.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login/sms";
    }
    return Promise.reject(err);
  }
);

export default http;
